// Gameframe resizing
(() => {
  function positionContainer(e) {
    const frame = document.querySelector('.gameframe');
    const viewport = document.querySelector('html');
    const nav = document.querySelector('.navbar');

    const navHeight = nav.offsetHeight;
    let width = viewport.clientWidth;
    let height = viewport.clientHeight;
    let cratio = 1024 / 768;
    let wratio = width / height;
    let awidth, aheight;

    if (width > 1024) {
      awidth = 1024;
      aheight = 768;
    } else {
      aheight = height - navHeight;
      awidth = aheight * cratio;
    }

    frame.style.setProperty('width', awidth + 'px');
    frame.style.setProperty('height', aheight + 'px');
    frame.style.setProperty('left','calc(50% - ' + (awidth / 2) + 'px)');
  }

  window.addEventListener('resize', positionContainer);
  window.addEventListener('DOMContentLoaded', positionContainer);

  positionContainer();
})();

(() => {
  gtag('event', 'conversion', {'send_to': 'AW-826410768/pPoNCPr-kHwQkI6IigM'});
  //console.log('gtag event triggered');
  // User selects "Play as guest" from game
  function gtag_report_conversion(url) {
    //console.log('gtag_report_conversion function called');
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', {
      'send_to': 'AW-826410768/w9leCNPL1YUBEJCOiIoD',
      'event_callback': callback
    });

    return false;
  }
})();
